import { addDays, formatISO } from 'date-fns';
import { useCallback } from 'react';
import { useFilterChangeCallback } from 'shared/hooks';
import { FILTER_KEY } from '../constants';

export const useDatesChangeHandler = () => {
  const onChange = useFilterChangeCallback(FILTER_KEY);

  return useCallback(
    (from: Date | undefined, to: Date | undefined) => {
      let fromValue = from;
      let toValue = to;

      if (fromValue && !toValue) {
        toValue = addDays(fromValue, 1);
      }
      if (toValue && !fromValue) {
        fromValue = addDays(toValue, -1);
      }
      if (fromValue && toValue && fromValue >= toValue) {
        toValue = addDays(fromValue, 1);
      }

      if (fromValue && toValue) {
        const gte = formatISO(fromValue, { representation: 'date' });
        const lte = formatISO(toValue, { representation: 'date' });

        onChange({ action: 'setDates', arguments: [gte, lte] });
      }
    },
    [onChange],
  );
};
